import { html, nothing } from "lit";
import type { ColWindow } from "./day-window-bounds";
import { dayWindowBounds } from "./day-window-bounds";

export type { ColWindow } from "./day-window-bounds";

/**
 * Column virtualization for a per-day row. When a window is active, renders only the items in
 * [start, end) and brackets them with left/right spacer divs sized to the off-window columns, so
 * total row width and column alignment match a fully-rendered row exactly. Returns the plain
 * mapped list when there is no window (week views) or the column width hasn't been measured yet.
 */
export function renderDayWindow<T>(
    items: T[],
    win: ColWindow | null,
    colWidth: number,
    renderItem: (item: T, index: number) => unknown
) {
    if (!win || colWidth <= 0) {
        return items.map(renderItem);
    }
    const { start, end, leftPad, rightPad } = dayWindowBounds(items.length, win, colWidth);
    return html`
        ${leftPad ? html`<div class="day-spacer" style="flex: 0 0 ${leftPad}px; width: ${leftPad}px"></div>` : nothing}
        ${items.slice(start, end).map((item, i) => renderItem(item, start + i))}
        ${rightPad
            ? html`<div class="day-spacer" style="flex: 0 0 ${rightPad}px; width: ${rightPad}px"></div>`
            : nothing}
    `;
}
